import React from 'react';

import Icon from '@wetransfer/transfer/component/icon';
import Helper from '@wetransfer/transfer/helper';
import { getMemberInitialsColors } from '@wetransfer/transfer/helper/team-discovery';
import { useCurrentTeam } from '@wetransfer/transfer/hooks/useCurrentTeam/useCurrentTeam';
import Store from '@wetransfer/transfer/store';

import styles from './TransferListTeamsContainer.module.scss';

const TeamListAvatarStack = (): JSX.Element | null => {
  const { user: self } = Store.getState();
  const { currentTeam, getUserIndexByEmail } = useCurrentTeam();

  if (!currentTeam) {
    return null;
  }

  const currentTeamMemberListWithoutSelf = currentTeam?.members.filter(
    ({ user }) => {
      return user.email !== self?.email;
    }
  );
  const teamOverFiveMembers = currentTeamMemberListWithoutSelf?.length > 4;
  const currentTeamMembers = currentTeamMemberListWithoutSelf.slice(0, 4);

  const teamMemberIcons = [
    {
      user: {
        profilePicture: self?.hasProfilePicture && {
          thumbnailUrl: self?.profile_picture?.thumbnail_url,
        },
        email: self.email,
        familyName: self.family_name,
        givenName: self.given_name,
        auth0UserId: self.id,
      },
    },
    ...currentTeamMembers,
  ].map(({ user }, index) => {
    const userProfilePicture = user?.profilePicture;
    const userInitials = Helper.getWorkspaceInitials(user);
    const userProfilePictureThumbnail = userProfilePicture?.thumbnailUrl;
    const userIndex = getUserIndexByEmail(user.email);
    const userInitialsColors = getMemberInitialsColors(userIndex);

    const style = {
      backgroundImage: userProfilePicture
        ? `url(${userProfilePictureThumbnail})`
        : null,
      backgroundColor: userProfilePicture
        ? null
        : `${userInitialsColors.backgroundColor}`,
      color: userProfilePicture ? null : userInitialsColors.fontColor,
    };

    return (
      <span
        title={user?.givenName || user?.email}
        key={user?.auth0UserId}
        className={
          userProfilePicture
            ? styles.ListContainerAvatar
            : styles.ListContainerAvatarInitials
        }
        style={{
          ...style,
          zIndex: currentTeamMembers.length - index,
        }}
      >
        {userProfilePicture ? null : userInitials}
      </span>
    );
  });

  return teamOverFiveMembers ? (
    <>
      {[
        ...teamMemberIcons,
        <span
          key={'icon_container__more_team_members'}
          className={styles.ListContainerMoreTeamMembers}
        >
          <Icon
            key="icon__more_team_members"
            type="More"
            width={10}
            height={10}
          />
        </span>,
      ]}
    </>
  ) : (
    <>{teamMemberIcons}</>
  );
};

export default TeamListAvatarStack;
